import { AbstractControl, ValidatorFn } from "@angular/forms";
import { IgniteNameComponent } from "../components/ignite-name/ignite-name.component";

export function MustHaveNameValidator(givenNamesControlName: string, surnameControlName: string): ValidatorFn {
  return (formGroup: AbstractControl) => {
    const givenNamesControl = formGroup?.get(givenNamesControlName);
    const surnameControl = formGroup?.get(surnameControlName);

    if (!givenNamesControl || !surnameControl) {
      return null;
    }

    if (givenNamesControl.value === IgniteNameComponent.NO_NAME_VALUE && surnameControl.value === IgniteNameComponent.NO_NAME_VALUE) {
      givenNamesControl.markAsTouched();
      surnameControl.markAsTouched();
      givenNamesControl.setErrors({ mustHaveName: true });
      surnameControl.setErrors({ mustHaveName: true });
    } else if (
      givenNamesControl.value !== IgniteNameComponent.NO_NAME_VALUE &&
      surnameControl.value === IgniteNameComponent.NO_NAME_VALUE
    ) {
      surnameControl.setErrors(null);
    } else if (
      givenNamesControl.value === IgniteNameComponent.NO_NAME_VALUE &&
      surnameControl.value !== IgniteNameComponent.NO_NAME_VALUE
    ) {
      givenNamesControl.setErrors(null);
    }
    return null;
  };
}
